import * as amlActions from "./actions/Aml.Actions";
import { connect } from "react-redux";
import { set_savelend_gdrive_link } from "./commands/Aml.Commands";

function mapStateToProps(state) {
  return {
    amlWarnings: state.aml.warnings,
    amlRules: state.aml.rules,
    amlProfile: state.aml.profile,
    investorNotes: state.aml.investorNotes,
    borrowerNotes: state.aml.borrowerNotes,
    gDriveLink: state.aml.gDriveLink,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAmlWarnings: () => {
      dispatch(amlActions.get_aml_warnings());
    },

    getInvestorDepositAmlWarnings: (investorId) => {
      dispatch(amlActions.get_investor_deposit_aml_warnings(investorId));
    },

    getLoanstepAmlWarnings: () => {
      dispatch(amlActions.get_loanstep_aml_warnings());
    },

    getAmlStatuses: (amlWarningsId) => {
      dispatch(amlActions.get_aml_statuses(amlWarningsId));
    },

    getLoanstepAmlStatuses: (amlWarningsId) => {
      dispatch(amlActions.get_loanstep_aml_statuses(amlWarningsId));
    },

    setAmlWarningStatus: (amlWarningsId, status, notes) => {
      const data = {
        WarningId: amlWarningsId,
        Status: status,
        Note: notes,
      };
      dispatch(amlActions.set_aml_warning_status(data, false));
    },

    setAmlWarningStatusAndCreateSendBackOrder: (
      amlWarningsId,
      status,
      notes,
      investorDepositId,
      bankAccount,
      bankName,
    ) => {
      const data = {
        WarningId: amlWarningsId,
        Status: status,
        Note: notes,
        InvestorDepositId: investorDepositId,
        BankAccountNumber: bankAccount,
        BankName: bankName,
      };
      dispatch(amlActions.set_aml_warning_status(data, true));
    },

    setLoanstepAmlWarningStatus: (amlWarningsId, status, notes) => {
      dispatch(
        amlActions.set_loanstep_aml_warning_status(
          amlWarningsId,
          status,
          notes,
        ),
      );
    },

    getAmlRules: () => {
      dispatch(amlActions.get_aml_rules());
    },

    setInvestorAmlRiskLevel: (riskLevel, note, investorId) => {
      dispatch(
        amlActions.set_investor_aml_risk_level(riskLevel, note, investorId),
      );
    },

    setBorrowerAmlRiskLevel: (riskLevel, note, borrowerId) => {
      dispatch(
        amlActions.set_borrower_aml_risk_level(riskLevel, note, borrowerId),
      );
    },

    getInvestorAmlNotes: (investorId) => {
      dispatch(amlActions.get_investor_aml_notes(investorId));
    },

    getBorrowerAmlNotes: (borrowerId) => {
      dispatch(amlActions.get_borrower_aml_notes(borrowerId));
    },

    setSavelendGDriveLink: (investorId, gDriveLink) => {
      dispatch(set_savelend_gdrive_link(investorId, gDriveLink));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps);
